import { render, staticRenderFns } from "./CrmNotificationList.vue?vue&type=template&id=726c0724&scoped=true&"
import script from "./CrmNotificationList.vue?vue&type=script&lang=js&"
export * from "./CrmNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./CrmNotificationList.vue?vue&type=style&index=0&id=726c0724&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c0724",
  null
  
)

export default component.exports